export default __webpack_public_path__ + "static/media/ib-icon.d88615b6.svg";